<template>
  <div class="articleDetails">
    <el-dialog title="" v-model="noticeShow" width="1100px" center>
      <div class="customCertificateContainer" v-if="noticeType == 1">
        <div class="customCertificate" ref="imageTofile">
          <img src="../assets/images/chapter.png" alt="">
          <div class="container">
            <div class="title">
              作品登记证书
            </div>
            <div class="itemContainer">
              <div class="item">
                <div class="blockView mb">
                  证书唯一哈希值:{{ dataDetails.uniqueCode }}
                </div>
                <div class="inlineView">
                  <div>
                    作品名称:{{ dataDetails.name }}
                  </div>
                  <div>
                    作品类型: {{
                        dataDetails.type == 1
                          ? "文字"
                          : dataDetails.type == 2
                            ? "口述"
                            : dataDetails.type == 3
                              ? "音乐"
                              : dataDetails.type == 4
                                ? "戏剧"
                                : dataDetails.type == 5
                                  ? "曲艺"
                                  : dataDetails.type == 6
                                    ? "舞蹈"
                                    : dataDetails.type == 7
                                      ? "杂技"
                                      : dataDetails.type == 8
                                        ? "美术"
                                        : dataDetails.type == 9
                                          ? "建筑"
                                          : dataDetails.type == 10
                                            ? "摄影"
                                            : dataDetails.type == 11
                                              ? "电影"
                                              : dataDetails.type == 12
                                                ? "似摄制电影方法创作作品"
                                                : dataDetails.type == 13
                                                  ? "工程设计图,产品设计图"
                                                  : dataDetails.type == 15
                                                    ? "地图,示意图"
                                                    : dataDetails.type == 17
                                                      ? "模型"
                                                      : dataDetails.type == 19
                                                        ? "录音作品"
                                                        : dataDetails.type == 20
                                                          ? "录象作品"
                                                          : dataDetails.type == 181
                                                            ? "其他作品"
                                                            : dataDetails.type
                    }}
                  </div>
                </div>
                <div class="inlineView">
                  <div>
                    著作权人:
                    <span v-for="item in dataDetails.worksAuthorList" :key="item">
                      {{ item.userName }}
                    </span>
                  </div>
                  <div>
                    作者:
                    <span v-for="item in dataDetails.worksAuthorList" :key="item">
                      {{ item.name || '-' }}
                    </span>
                  </div>
                </div>
                <div class="inlineView">
                  <div>
                    作品性质:
                    {{
                        dataDetails.creation == 0 && dataDetails.worksAuthorList[0].postCode == 1
                          ? "原创"
                          : dataDetails.creation == 0 && dataDetails.worksAuthorList[0].postCode == 100
                            ? "社创"
                            : dataDetails.creation == 1
                              ? "改编"
                              : dataDetails.creation == 2
                                ? "翻译"
                                : dataDetails.creation == 3
                                  ? "汇编"
                                  : dataDetails.creation == 4
                                    ? "注释"
                                    : dataDetails.creation == 5
                                      ? "整理"
                                      : dataDetails.creation == 6
                                        ? "其他"
                                        : dataDetails.creation
                    }}
                  </div>
                  <div>
                    著作权获得方式:
                    {{
                        dataDetails.copyrightRightsGet == 0 && dataDetails.worksAuthorList[0].postCode == 1
                          ? "原创"
                          : dataDetails.copyrightRightsGet == 0 && dataDetails.worksAuthorList[0].postCode == 100
                            ? "社创"
                            : dataDetails.copyrightRightsGet == 1
                              ? "转让"
                              : dataDetails.copyrightRightsGet == 2
                                ? "继承"
                                : dataDetails.copyrightRightsGet == 3
                                  ? "承受"
                                  : dataDetails.copyrightRightsGet == 4
                                    ? "赠予"
                                    : dataDetails.copyrightRightsGet == 5
                                      ? "其他"
                                      : dataDetails.creation
                    }}
                  </div>
                </div>
              </div>

              <div class="item">
                <div class="blockView mb">
                  著作权权利生产方式:
                  {{
                      dataDetails.copyrightProduceMode == 0
                        ? "个人"
                        : dataDetails.copyrightProduceMode == 1
                          ? "合作"
                          : dataDetails.copyrightProduceMode == 2
                            ? "法人"
                            : dataDetails.copyrightProduceMode == 3
                              ? "职务"
                              : dataDetails.copyrightProduceMode == 4
                                ? "委托"
                                : dataDetails.copyrightProduceMode
                  }}
                </div>
                <div class="blockView">
                  著作权权利:
                  <span v-for="(items, indexs) in dataDetails.worksAuthorList[0].rightsCategoryArray" :key="indexs">
                    {{
                        items == 0
                          ? "发表权"
                          : items == 1
                            ? "署名权"
                            : items == 2
                              ? "修改权"
                              : items == 3
                                ? "保护作品完整权"
                                : items == 4
                                  ? "复制权"
                                  : items == 5
                                    ? "发行权"
                                    : items == 6
                                      ? "出租权"
                                      : items == 7
                                        ? "展览权"
                                        : items == 8
                                          ? "表演权"
                                          : items == 9
                                            ? "放映权"
                                            : items == 10
                                              ? "广播权"
                                              : items == 11
                                                ? "信息网络传播权"
                                                : items == 12
                                                  ? "摄制权"
                                                  : items == 13
                                                    ? "改编权"
                                                    : items == 14
                                                      ? "翻译权"
                                                      : items == 15
                                                        ? "汇编权"
                                                        : items == 16
                                                          ? "其他"
                                                          : items
                    }}
                  </span>
                </div>
              </div>

              <div class="item">
                <div class="inlineView">
                  <div>
                    创作完成日期:{{ dataDetails.worksCreateTime }}
                  </div>
                  <div v-if="dataDetails.worksPublishTime">
                    首次发表日期:{{ dataDetails.worksPublishTime || '-' }}
                  </div>
                  <div v-else></div>
                </div>
                <div class="blockView">
                  以上事项根据（<span v-for="item in dataDetails.worksAuthorList" :key="item">
                    {{ item.userName }}
                  </span>）申请，并附《唯一著作权承诺书》经 龙源知识区块链平台审核，予以登记，特发此证。
                </div>
              </div>
              <div class="item">
                <div class="blockView mb">
                  发证日期:{{ dataDetails.lyUplinkPushTime }}
                </div>
                <div class="inlineView">
                  <div>
                    认证机构：知识区块链基金会
                  </div>
                  <div>
                    登记机构盖章
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-button type="primary" class="button_" @click="toImage">保存证书</el-button>
      </div>
      <div class="defaultCertificate" v-if="noticeType == 3">
        <img :src="dataDetails.uplinkCode">
      </div>
      <div class="why" v-if="noticeType == 2">
        {{ dataDetails.lyErrorContent }}
      </div>
      <div class="why" v-if="dataDetails.uplinkStatus == 4">
        {{ dataDetails.errorContent }}
      </div>
    </el-dialog>
    <div class="backPage" v-if="historyLen > 1" @click="$router.go(-1);">返回上一页</div>
    <div class="examineView" style="margin-top: 20px;"
      v-if="dataDetails.uplinkType == 3 || dataDetails.uplinkType == 1">
      <div class="left_">
        <div class="title_">龙源证书申请状态</div>
        <div class="status_" :style="{
          color: dataDetails.lyUplinkStatus == 3 ? '#4A9C5E' : '#CC3F1F',
        }">
          {{
              dataDetails.lyUplinkStatus == 0
                ? "草稿箱"
                : dataDetails.lyUplinkStatus == 1
                  ? "审核中"
                  : dataDetails.lyUplinkStatus == 2
                    ? "已发布"
                    : dataDetails.lyUplinkStatus == 3
                      ? "未通过"
                      : dataDetails.lyUplinkStatus
          }}
        </div>
      </div>
      <!-- <div class="right_" v-if="dataDetails.lyUplinkStatus == 2 || dataDetails.lyUplinkStatus == 3 && dataDetails.uplinkStatus == 2 || dataDetails.uplinkStatus == 3"
        @click="openConfirm(1, dataDetails.lyUplinkStatus)">
        {{ dataDetails.lyUplinkStatus == 2 ? "查看证书" : "查看原因" }}
      </div> -->
      <div v-if="dataDetails.uplinkType == 3">
        <div class="right_" v-if="dataDetails.uplinkStatus == 2 && dataDetails.lyUplinkStatus == 2"
          @click="openConfirm(1, dataDetails.lyUplinkStatus)">
          查看证书
        </div>
      </div>
      <div v-else>
        <div class="right_" v-if="dataDetails.lyUplinkStatus == 2" @click="openConfirm(1, dataDetails.lyUplinkStatus)">
          查看证书
        </div>
      </div>
      <div class="right_" v-if="dataDetails.lyUplinkStatus == 3" @click="openConfirm(1, dataDetails.lyUplinkStatus)">
        查看原因
      </div>
    </div>

    <!-- examineMessage -->

    <div class="examineView" v-if="dataDetails.uplinkType == 3 || dataDetails.uplinkType == 2">
      <div class="left_">
        <div class="title_">第三方申请状态</div>
        <div class="status_" :style="{
          color: dataDetails.uplinkStatus == 3 ? '#4A9C5E' : '#CC3F1F',
        }">
          {{
              dataDetails.uplinkStatus == 0
                ? "草稿箱"
                : dataDetails.uplinkStatus == 1
                  ? "审核中"
                  : dataDetails.uplinkStatus == 2
                    ? "已发布"
                    : dataDetails.uplinkStatus == 3
                      ? "未通过"
                      : dataDetails.uplinkStatus
          }}
        </div>
      </div>
      <div v-if="dataDetails.uplinkType == 3">
        <div class="right_" v-if="dataDetails.uplinkStatus == 2 && dataDetails.lyUplinkStatus == 2"
          @click="openConfirm(2, dataDetails.uplinkStatus)">
          查看证书
        </div>
      </div>
      <div v-else>
        <div class="right_" v-if="dataDetails.uplinkStatus == 2" @click="openConfirm(2, dataDetails.uplinkStatus)">
          查看证书
        </div>
      </div>
      <div class="right_" v-if="dataDetails.uplinkStatus == 3" @click="openConfirm(2, dataDetails.uplinkStatus)">
        查看原因
      </div>
    </div>
    <div class="titleWap" style="margin: 0">作品信息</div>
    <div class="workInformationWap">
      <div class="listTypeOne">
        <div class="listTypeOneLeft">
          <div>作品名称</div>
          <div>{{ dataDetails.name }}</div>
        </div>
        <div class="listTypeOneRight">
          <div>作品类型</div>
          <div>
            {{
                dataDetails.type == 1
                  ? "文字"
                  : dataDetails.type == 2
                    ? "口述"
                    : dataDetails.type == 3
                      ? "音乐"
                      : dataDetails.type == 4
                        ? "戏剧"
                        : dataDetails.type == 5
                          ? "曲艺"
                          : dataDetails.type == 6
                            ? "舞蹈"
                            : dataDetails.type == 7
                              ? "杂技"
                              : dataDetails.type == 8
                                ? "美术"
                                : dataDetails.type == 9
                                  ? "建筑"
                                  : dataDetails.type == 10
                                    ? "摄影"
                                    : dataDetails.type == 11
                                      ? "电影"
                                      : dataDetails.type == 12
                                        ? "似摄制电影方法创作作品"
                                        : dataDetails.type == 13
                                          ? "工程设计图,产品设计图"
                                          : dataDetails.type == 15
                                            ? "地图,示意图"
                                            : dataDetails.type == 17
                                              ? "模型"
                                              : dataDetails.type == 19
                                                ? "录音作品"
                                                : dataDetails.type == 20
                                                  ? "录象作品"
                                                  : dataDetails.type == 181
                                                    ? "其他作品"
                                                    : dataDetails.type
            }}
          </div>
        </div>
      </div>
      <div class="listTypeTwo" v-if="dataDetails.poster">
        <div class="title">作品封面</div>
        <div class="content">
          <div>
            <img :src="dataDetails.poster" alt="cover" />
          </div>
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">创作性质</div>
        <div class="content">
          {{
              dataDetails.creation == 0 && dataDetails.worksAuthorList[0].postCode == 1
                ? "原创"
                : dataDetails.creation == 0 && dataDetails.worksAuthorList[0].postCode == 100
                  ? "社创"
                  : dataDetails.creation == 1
                    ? "改编"
                    : dataDetails.creation == 2
                      ? "翻译"
                      : dataDetails.creation == 3
                        ? "汇编"
                        : dataDetails.creation == 4
                          ? "注释"
                          : dataDetails.creation == 5
                            ? "整理"
                            : dataDetails.creation == 6
                              ? "其他"
                              : dataDetails.creation
          }}
        </div>
      </div>
      <!-- <div class="listTypeTwo">
        <div class="title">创作性质说明</div>
        <div class="content">
          <div>
            <img src="" alt="cover" />
          </div>
        </div>
      </div> -->
      <div class="listTypeThree">
        <div class="title">创作时间</div>
        <div class="content">{{ dataDetails.createTime }}</div>
      </div>
      <div class="listTypeThree">
        <div class="title">创作地点</div>
        <div class="content">
          {{ dataDetails.worksCreationCountry }}/{{
              dataDetails.worksCreationCity
          }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">发表状态</div>
        <div class="content">
          {{ dataDetails.worksPublishStatus == 0 ? "未发表" : "已发表" }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">发表日期</div>
        <div class="content">{{ dataDetails.worksPublishTime }}</div>
      </div>
      <div class="listTypeThree">
        <div class="title">发表地点</div>
        <div class="content">
          {{ dataDetails.worksPublishCountry }}/{{
              dataDetails.worksPublishCity
          }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">作品权利保证书</div>
        <div class="content link-btn" @click="openUrl(files?.C3?.[0].fileUrl)">
          {{ files?.C3?.[0]?.fileName }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">作品创作过程证明</div>
        <div class="content link-btn" @click="openUrl(files?.C2?.[0].fileUrl)">
          {{ files?.C2?.[0]?.fileName }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">著作权许可使用合同</div>
        <div class="content link-btn" @click="openUrl(files?.C8?.[0].fileUrl)">
          {{ files?.C8?.[0]?.fileName }}
        </div>
      </div>
      <div class="listTypeThree">
        <div class="title">唯一著作权平台承诺书</div>
        <div class="content link-btn" @click="openUrl(files?.C16?.[0].fileUrl)">
          {{ files?.C16?.[0]?.fileName }}
        </div>
      </div>

    </div>

    <div class="titleWap">权属信息</div>


    <div class="workInformationWap">

      <div class="listTypeThree">
        <div class="title">
          权利获得方式
        </div>
        <div class="content">
          {{ CONPYRIGHT_RIGHTS_GET[dataDetails.copyrightRightsGet] }}
        </div>
      </div>
      <div style="margin-bottom: 20px;" class="link-btn"
        @click="openUrl(files?.[fileType.qunashuMap?.[dataDetails.copyrightRightsGet]]?.[0]?.fileUrl)">
        {{ files?.[fileType.qunashuMap?.[dataDetails.copyrightRightsGet]]?.[0].fileName }}
      </div>

      <div class="listTypeThree">
        <div class="title">权利生产方式</div>
        <div class="content">
          {{ CONPYRIGHT_PRODUCE_MODE_TYPE[dataDetails.copyrightProduceMode] }}
        </div>


      </div>
      <div style="margin-bottom: 20px;" class="link-btn"
        @click="openUrl(files?.[fileType.fangshiMap?.[dataDetails.copyrightProduceMode]]?.[0].fileUrl)">
        {{ files?.[fileType.fangshiMap?.[dataDetails.copyrightProduceMode]]?.[0].fileName }}
      </div>
    </div>

    <!-- <div class="listTypeThree">
      <div class="title">权利获得方式</div>
      <div class="content">
        {{ dataDetails.copyrightRightsGet }}
      </div>
    </div> -->
    <!-- <div class="multiple">
      <div class="item" v-for="(item, index) in 3" :key="index">
        <img src="" alt="" />
      </div>
    </div> -->

    <!-- <div class="titleWap2">权利生产方式 <span>合作作品</span></div>
    <div class="multiple">
      <div class="item">
        <img src="" alt="" />
      </div>
    </div> -->

    <div class="titleWap" style="marign-bottom: 0">著作权人</div>
    <div class="copyrightOwner" v-for="(item, index) in dataDetails.worksAuthorList" :key="index">
      <div class="titleWap2">第{{ index + 1 }}位</div>
      <div class="listTypeOne">
        <div class="item">
          <div>姓名</div>
          <div>{{ item.userName }}</div>
        </div>
        <div class="item">
          <div>证件号码</div>
          <div>{{ item.idNumber }}</div>
        </div>
      </div>
      <div class="listTypeOne">
        <div class="item" v-if="item.sex">
          <div>性别</div>
          <div>{{ item.sex == "1" ? "男" : "女" }}</div>
        </div>
        <div class="item" v-if="item.ethnic">
          <div>民族</div>
          <div>{{ item.ethnic }}</div>
        </div>
      </div>
      <div class="listTypeOne" v-if="item.birthDate">
        <div class="item">
          <div>出生日期</div>
          <div>{{ item.birthDate }}</div>
        </div>
        <!-- <div class="item">
          <div>证件地址</div>
          <div>北京</div>
        </div> -->
      </div>
      <div class="listTypeOne" v-if="item.issueDate">
        <div class="item">
          <div>证件签发日期</div>
          <div>{{ item.issueDate }}</div>
        </div>
        <div class="item" v-if="item.expirationDate">
          <div>证件失效日期</div>
          <div>{{ item.expirationDate }}</div>
        </div>
      </div>
      <div class="listTypeTwo" v-if="item.cardHoldImage || item.cardBackImage || item.cardFrontImage">
        <div class="title">证件图片</div>
        <div class="content">
          <div v-if="item.cardHoldImage">
            <img :src="item.cardHoldImage" alt="cover" />
          </div>
          <div v-if="item.cardBackImage">
            <img :src="item.cardBackImage" alt="cover" />
          </div>
          <div v-if="item.cardFrontImage">
            <img :src="item.cardFrontImage" alt="cover" />
          </div>
        </div>
      </div>
      <!-- <div class="listTypeOne">
        <div class="item">
          <div>作者</div>
          <div>张三</div>
        </div>
        <div class="item">
          <div>署名</div>
          <div>张三</div>
        </div>
      </div>
      <div class="listTypeOne">
        <div class="item">
          <div>作者</div>
          <div>张三</div>
        </div>
        <div class="item">
          <div>署名</div>
          <div>张三</div>
        </div>
      </div> -->
    </div>
    <div class="titleWap">权利人</div>
    <div v-for="(item, index) in dataDetails.worksAuthorList" :key="index" class="obligeeView">
      <div class="obligeeWap">
        <div class="name">权利人:{{ item.userName }}</div>

        <!-- <div class="obligeeList">
          <el-radio-group v-model="obligee">
            <el-radio
              :label="1"
              >张三</el-radio
            >
          </el-radio-group> 
        </div>-->
      </div>
      <div class="titleWap" v-if="item.rightsCategoryArray">权利拥有情况</div>
      <div class="haveSituation">
        <div v-for="(items, indexs) in item.rightsCategoryArray" :key="indexs">
          {{
    items == 0
      ? "发表权"
      : items == 1
        ? "署名权"
        : items == 2
          ? "修改权"
          : items == 3
            ? "保护作品完整权"
            : items == 4
              ? "复制权"
              : items == 5
                ? "发行权"
                : items == 6
                  ? "出租权"
                  : items == 7
                    ? "展览权"
                    : items == 8
                      ? "表演权"
                      : items == 9
                        ? "放映权"
                        : items == 10
                          ? "广播权"
                          : items == 11
                            ? "信息网络传播权"
                            : items == 12
                              ? "摄制权"
                              : items == 13
                                ? "改编权"
                                : items == 14
                                  ? "翻译权"
                                  : items == 15
                                    ? "汇编权"
                                    : items == 16
                                      ? "其他"
                                      : items
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ElMessageBox } from "element-plus";
import { articleGetWorksInfo } from "../api/interfaceList";
import html2canvas from "html2canvas"
export default {
  name: "articleDetails",
  data() {
    return {
      uniqueCode: "",
      dataDetails: "",
      noticeShow: false,
      noticeType: 0
    };
  },
  computed: {
    historyLen() {
      return window.history.length
    },
    files() {
      return this.dataDetails?.worksFiles?.reduce((current, item) => {
        (current[item.type] ?? (current[item.type] = [])).push({
          fileUrl: item.fileUrl,
          fileType: item.fileType,
          fileName: item.fileName,
        });
        return current;
      }, [])
    },
    fileType() {
      return {
        qunashuMap: { 0: "C3", 1: "C11", 2: "C12", 3: "C13", 4: "C14" },
        fangshiMap: { 1: "C6", 2: "C4", 3: "C5", 4: "C7" }
      }
    },
    CONPYRIGHT_PRODUCE_MODE_TYPE() {
      return {
        0: "个人",
        1: "合作",
        2: "法人",
        3: "职务",
        4: "委托",
      }
    },
    CONPYRIGHT_RIGHTS_GET() {
      return {
        0: '原创',
        1: '转让',
        2: '继承',
        3: '承受',
        4: '赠予',
        5: '其他'
      }
    }


  },
  methods: {
    openUrl(url) {
      console.log(url, 'url')
      window.open(url);
    },
    openConfirm(status, type) {
      this.noticeShow = true
      if (status == 1) {
        type == 2 ? this.noticeType = 1 : this.noticeType = 2
      } else {
        type == 2 ? this.noticeType = 3 : this.noticeType = 4
      }
      // let content =
      //   type == 2
      //     ? `<img style="width:100%;" src=${this.dataDetails.uplinkCode}>`
      //     : this.dataDetails.errorContent;
      // ElMessageBox.confirm(`${content}`, {
      //   cancelButtonText: "取消",
      //   confirmButtonText: "确定",
      //   draggable: true,
      //   dangerouslyUseHTMLString: true,
      //   showCancelButton: false,
      // });
    },
    toImage() {
      html2canvas(this.$refs.imageTofile, {
        useCORS: true,
        logging: true,
        backgroundColor: null // 解决生成的图片有白边
      }).then((canvas) => {
        let url = canvas.toDataURL("image/jpeg")
        const link = document.createElement("a");//创建一个a标签
        link.style.display = "none";    //去掉此标签的所有样式避免展示出a标签
        link.href = url;           //把获取到的流文件放到href属性里
        link.setAttribute("download", "certificate.png");//调用download属性，并添加名字
        document.body.appendChild(link);//添加这个a标签到body上
        link.click(); //触发click事件
      });
    },
    articleGetWorksInfo() {
      articleGetWorksInfo({
        contentUplinkCode: this.uniqueCode,
      }).then((res) => {
        this.dataDetails = res.data;
      });
    },
  },
  mounted() {
    this.uniqueCode = this.$route.query.uniqueCode;
    this.articleGetWorksInfo();
  },
  components: {},
};
</script>
<style lang="scss" scoped>
.articleDetails {
  width: 522px;
  margin: auto;

  .customCertificateContainer {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .button_ {
      margin: 20px auto;
    }

    .customCertificate {
      position: relative;
      width: 1000px;
      height: 708px;
      background: url('.././assets/images/certificateBackground.png');
      background-size: cover;
      background-repeat: no-repeat;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "Microsoft YaHei", Arial, Helvetica, sans-serif, "宋体";
      padding-top: 40px;
      box-sizing: border-box;

      img {
        width: 160px;
        position: absolute;
        right: 158px;
        bottom: 82px;
      }

      .container {
        .itemContainer {
          width: 690px;
          font-size: 14px;
          font-weight: bold;
          color: #000000;

          .mb {
            margin-bottom: 12px;
          }

          .item:last-of-type {
            margin: 0;
          }

          .item {
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            margin-bottom: 36px;

            .blockView {
              width: 100%;

              span {
                margin-right: 10px;
              }

              span:last-of-type {
                margin-right: 0;
              }
            }

            .inlineView:last-of-type {
              margin: 0;
            }

            .inlineView {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;

              div {
                width: 305px;

                span {
                  margin-right: 10px;
                }

                span:last-of-type {
                  margin-right: 0;
                }
              }


            }
          }
        }

        .title {
          font-size: 60px;
          font-weight: bold;
          color: #000000;
          text-align: center;
          margin: 32px;
        }
      }
    }
  }

  .defaultCertificate {
    width: 400px;
    margin: auto;

    img {
      width: 100%;
    }
  }

  .backPage {
    width: 140px;
    height: 40px;
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #008AEA;
    border-radius: 8px;
    margin: 20px 0;
    cursor: pointer;
  }

  .examineView {
    width: 522px;
    height: 56px;
    background: #f5f7fa;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    // margin: 30px 0 24px;
    margin-bottom: 24px;

    .right_ {
      width: 80px;
      height: 40px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      line-height: 40px;
      background: #008aea;
      border-radius: 8px;
      text-align: center;
      cursor: pointer;
    }

    .left_ {
      display: flex;
      align-items: center;

      .title_ {
        width: 100px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 18px;
      }

      .status_ {
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }

  .obligeeView {
    margin-bottom: 30px;

    .obligeeWap {
      display: flex;
      align-items: center;

      .name {
        // width: 64px;
        height: 100%;
        font-size: 14px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }

  .btnWap {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 50px 0;

    div {
      height: 40px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      line-height: 40px;
      text-align: center;
      border-radius: 8px;
      cursor: pointer;
    }

    div:nth-of-type(1) {
      width: 120px;
      border: 1px solid #c0c4cc;
      margin-right: 72px;
      color: #909399;
    }

    div:nth-of-type(2) {
      width: 240px;
      background: #008aea;
      color: #ffffff;
    }
  }

  .haveSituation {
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    div {
      padding: 8px 12px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiM;
      color: #008aea;
      background: #f5f7fa;
      border-radius: 12px;
      margin: 0 16px 16px 0;
      font-weight: 800;
    }
  }

  .copyrightOwner {
    width: 526px;
    margin-top: 48px;

    .listTypeTwo {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;

      .title {
        width: 70px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 11px;
      }

      .content {
        display: flex;
        align-items: center;

        div {
          width: 144px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          overflow: hidden;

          img {
            width: 100%;
          }
        }
      }
    }
  }

  .listTypeOne {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .item {
      width: 200px;
      display: flex;
      align-items: center;

      div:nth-of-type(1) {
        width: 70px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 11px;
      }

      div:nth-of-type(2) {
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }
  }

  .multiple {
    display: flex;
    align-items: center;
    margin: 28px 0;

    .item {
      width: 160px;
      height: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 24px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }

  .workInformationWap {
    margin-top: 18px;

    .imgListWapTypeOne {
      width: 712px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .item {
        width: 160px;

        div:nth-of-type(2) {
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #606266;
          margin: 4px 0 20px;
        }

        div:nth-of-type(1) {
          width: 100%;
          height: 240px;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;

          img {
            width: 100%;
          }
        }
      }
    }

    .listTypeThree {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .title {
        width: 64px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 18px;
      }

      .content {
        width: 416px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #606266;
      }
    }

    .listTypeTwo {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .title {
        width: 64px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
        margin-right: 18px;
      }

      .content {
        width: 144px;
        display: flex;
        justify-content: center;
        align-items: center;

        div {
          width: 100%;
          overflow: hidden;

          img {
            width: 100%;
          }
        }
      }
    }

    .listTypeOne {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .listTypeOneRight {
        display: flex;
        align-items: center;
        margin-left: 140px;

        div:nth-of-type(1) {
          width: 64px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          margin-right: 18px;
        }

        div:nth-of-type(2) {
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #606266;
        }
      }

      .listTypeOneLeft {
        display: flex;
        align-items: center;

        div:nth-of-type(1) {
          width: 64px;
          font-size: 12px;
          font-family: AlibabaPuHuiTiR;
          color: #303133;
          margin-right: 18px;
        }

        div:nth-of-type(2) {
          font-size: 13px;
          font-family: AlibabaPuHuiTiR;
          color: #606266;
        }
      }
    }
  }

  .titleWap {
    font-size: 18px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    margin: 30px 0 18px;
    font-weight: 800;

    .styleCss {
      margin: 50px 0 00;
    }
  }

  .titleWap2 {
    font-size: 12px;
    font-family: AlibabaPuHuiTiR;
    color: #303133;
    margin-bottom: 20px;

    span {
      margin-left: 11px;
      font-size: 13px;
      font-family: AlibabaPuHuiTiR;
      color: #606266;
    }
  }
}


.link-btn {
  font-size: 12px;
  color: "#606266";
  cursor: pointer;

  &:hover {
    color: #008AEA;
    text-decoration: dashed;
  }
}
</style>
